
import { BannerSize, BannerSizeConfig, BANNER_SIZES } from '@/types/banner';

/**
 * Returns an array of the most popular banner sizes
 */
export const getPopularBannerSizes = (): BannerSizeConfig[] => {
  // Most commonly used web banner sizes
  const popularSizeValues: BannerSize[] = [
    'medium_rectangle',   // 300x250
    'leaderboard',        // 728x90
    'large_rectangle',    // 336x280
    'half_page',          // 300x600
    'mobile_banner',      // 320x50
    'billboard'           // 970x250
  ];
  
  return BANNER_SIZES.filter(size => popularSizeValues.includes(size.value));
};

/**
 * Creates a placeholder banner image URL for a given size
 */
export const createPlaceholderBannerImage = (size: BannerSize): string => {
  const sizeConfig = BANNER_SIZES.find(s => s.value === size);
  if (!sizeConfig) return '';
  
  // Use placeholder service to create a sized image
  return `https://via.placeholder.com/${sizeConfig.width}x${sizeConfig.height}`;
};

/**
 * Formats a banner size as a readable string
 */
export const formatBannerSize = (size: BannerSize): string => {
  const sizeConfig = BANNER_SIZES.find(s => s.value === size);
  if (!sizeConfig) return '';
  
  return `${sizeConfig.name} (${sizeConfig.width}×${sizeConfig.height})`;
};

/**
 * Categorizes banner sizes based on their type
 */
export const categorizeBannerSizes = () => {
  return {
    rectangles: BANNER_SIZES.filter(size => size.value.includes('rectangle')),
    horizontals: BANNER_SIZES.filter(size => 
      size.value.includes('leaderboard') || 
      size.value === 'billboard' ||
      size.value === 'mobile_banner'
    ),
    verticals: BANNER_SIZES.filter(size => 
      size.value.includes('skyscraper') || 
      size.value === 'half_page' ||
      size.value === 'vertical_banner' ||
      size.value === 'portrait'
    ),
    squares: BANNER_SIZES.filter(size => 
      size.value.includes('square')
    )
  };
};

/**
 * Check if a banner size is popular
 */
export const isBannerSizePopular = (size: BannerSize): boolean => {
  const popularSizes = getPopularBannerSizes();
  return popularSizes.some(popularSize => popularSize.value === size);
};

/**
 * Get a display string for a banner size
 */
export const getBannerSizeDisplay = (size: BannerSize): string => {
  const sizeConfig = BANNER_SIZES.find(s => s.value === size);
  if (!sizeConfig) return '';
  
  return `${sizeConfig.name} (${sizeConfig.width}×${sizeConfig.height})`;
};
